(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahs-footer"] && !Shopify.designMode) return;
  try {
    
  class AhsMobilePackageBar extends HTMLElement {
    #events;
    #footerObserver;
    #resizeObserver;

    connectedCallback() {
      this.#events?.abort();
      this.#events = new AbortController();
      this.querySelector('a')?.addEventListener('click', this.#choosePackage, { signal: this.#events.signal });
      this.#prepareTarget();

      const footer = this.previousElementSibling;
      if (footer && 'IntersectionObserver' in window) {
        this.#footerObserver = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-footer-visible', entry.isIntersecting);
        });
        this.#footerObserver.observe(footer);
      }

      const bar = this.querySelector('nav');
      if (bar && 'ResizeObserver' in window) {
        this.#resizeObserver = new ResizeObserver(() => {
          const height = Math.ceil(bar.getBoundingClientRect().height);
          if (height > 0) this.style.setProperty('--ahs-mobile-bar-height', `${height}px`);
        });
        this.#resizeObserver.observe(bar);
      }
    }

    disconnectedCallback() {
      this.#events?.abort();
      this.#footerObserver?.disconnect();
      this.#resizeObserver?.disconnect();
    }

    #prepareTarget() {
      const target = this.dataset.page === 'product'
        ? document.querySelector('main variant-picker[data-template-product-match="true"]')
        : document.getElementById('ahs-packages');
      if (!target) return null;
      if (!target.id) target.id = 'ahs-mobile-package-selector';
      const link = this.querySelector('a');
      if (link) link.setAttribute('href', `#${target.id}`);
      return target;
    }

    #choosePackage = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = this.#prepareTarget();
      if (!target) return;
      event.preventDefault();
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    };
  }

  if (!customElements.get('ahs-mobile-package-bar')) {
    customElements.define('ahs-mobile-package-bar', AhsMobilePackageBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahs-testimonials"] && !Shopify.designMode) return;
  try {
    
  class AhsTestimonials extends HTMLElement {
    #rail;
    #cards = [];
    #events;
    #resizeObserver;
    #timer;

    connectedCallback() {
      this.#rail = this.querySelector('.ahs-testimonials__rail');
      if (!this.#rail) return;
      this.#cards = Array.from(this.#rail.children);
      if (!this.#cards.length) return;
      this.#events?.abort();
      this.#events = new AbortController();
      const options = { signal: this.#events.signal };
      this.querySelector('.ahs-testimonials__controls').hidden = false;
      this.querySelector('[data-direction="previous"]').addEventListener('click', () => this.#move(-this.#visibleCount()), options);
      this.querySelector('[data-direction="next"]').addEventListener('click', () => this.#move(this.#visibleCount()), options);
      this.#rail.addEventListener('scroll', () => {
        clearTimeout(this.#timer);
        this.#timer = setTimeout(() => this.#update(), 100);
      }, { ...options, passive: true });
      this.#rail.addEventListener('keydown', this.#onKeydown, options);
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.ahs-testimonials__card');
        const index = this.#cards.indexOf(card);
        if (index >= 0) this.#goTo(index, 'auto');
      }, options);
      if ('ResizeObserver' in window) {
        this.#resizeObserver = new ResizeObserver(() => this.#update());
        this.#resizeObserver.observe(this.#rail);
      }
      this.#update();
    }

    disconnectedCallback() {
      this.#events?.abort();
      this.#resizeObserver?.disconnect();
      clearTimeout(this.#timer);
    }

    #step() {
      return this.#cards.length > 1
        ? this.#cards[1].offsetLeft - this.#cards[0].offsetLeft
        : this.#cards[0].getBoundingClientRect().width;
    }

    #visibleCount() {
      const gap = parseFloat(getComputedStyle(this.#rail).columnGap) || 0;
      return Math.max(1, Math.floor((this.#rail.clientWidth + gap + 1) / this.#step()));
    }

    #firstIndex() {
      return Math.max(0, Math.min(this.#cards.length - 1, Math.round(this.#rail.scrollLeft / this.#step())));
    }

    #update() {
      if (!this.#rail.clientWidth) return;
      const first = this.#firstIndex();
      const start = first + 1;
      const end = Math.min(this.#cards.length, first + this.#visibleCount());
      const message = start === end
        ? this.dataset.singleCounter.replace('[number]', start)
        : this.dataset.counter.replace('[start]', start).replace('[end]', end);
      const counter = this.querySelector('.ahs-testimonials__counter');
      if (counter.textContent !== message) counter.textContent = message;
      this.querySelector('[data-direction="previous"]').disabled = this.#rail.scrollLeft <= 2;
      this.querySelector('[data-direction="next"]').disabled = this.#rail.scrollLeft + this.#rail.clientWidth >= this.#rail.scrollWidth - 2;
    }

    #goTo(index, behavior) {
      const bounded = Math.max(0, Math.min(this.#cards.length - 1, index));
      const motion = behavior || (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
      this.#rail.scrollTo({ left: this.#cards[bounded].offsetLeft - this.#cards[0].offsetLeft, behavior: motion });
    }

    #move(amount) {
      this.#goTo(this.#firstIndex() + amount);
    }

    #onKeydown = (event) => {
      if (event.target !== this.#rail || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowRight') this.#move(1);
      else if (event.key === 'ArrowLeft') this.#move(-1);
      else if (event.key === 'Home') this.#goTo(0);
      else if (event.key === 'End') this.#goTo(this.#cards.length - 1);
      else return;
      event.preventDefault();
    };
  }

  if (!customElements.get('ahs-testimonials')) customElements.define('ahs-testimonials', AhsTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
